// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraDatePickerDropDown } from '@front/controls/elements/DateTimePicker/TerceraDatePickerDropDown';
import { TerceraButtonsPopup } from '@front/controls/elements/TerceraButtonsPopup';
import { TerceraMultiComboBoxPopup } from '@front/controls/elements/TerceraMultiComboBoxPopup';
import { TerceraNumeric } from '@front/controls/elements/TerceraNumeric';
import { PopupErrorScreen } from '@front/controls/screen/PopupErrorScreen';
import { PositionExerciseRequestScreen } from '@front/controls/screen/PositionExerciseRequestScreen';
import { PropertySetupScreenForIndicator } from '@front/controls/screen/PropertySetupScreenForIndicator';
import { TerceraMessageBox } from '@front/controls/screen/TerceraMessageBox';
import { TerceraRiskWarningMessageScreen } from '@front/controls/screen/TerceraRiskWarningMessageScreen';
import { TerceraBrokerMessageScreen } from '@front/controls/screen/TerceraBrokerMessageScreen';
import { AlertMessageBox } from '@front/controls/screen/AlertMessageBox';
import { ModifyOrderScreen } from '@front/controls/screen/ModifyOrderScreen';
import { EditPositionScreen } from '@front/controls/screen/EditPositionScreen';
import { WorkSpaceManager } from '@front/controls/WorkSpace/WorkSpaceManager';
import { ClosePositionsMutually } from '@front/controls/panels/ClosePositionsMutually';
import { ExternalScreen } from '@front/controls/screen/ExternalScreen';
import { EntitlementSubscribeDocumentScreen } from '@front/controls/screen/EntitlementSubscribeDocumentScreen';
import { TerceraAddOverlayScreen } from '@front/controls/screen/TerceraAddOverlayScreen';
import { RactiveTooltip } from '@front/controls/misc/Decorators';
import { ConfirmationScreen } from './Trading/ConfirmationScreen';
export * from '@front/controls/screen/CertificateInfoScreen';
class _ApplicationHandlersInitializer {
    Initialize() {
        RactiveTooltip.tooltipHandlerInitialize();
        PopupErrorScreen.PopupErrorHandlerInitialize();
        TerceraButtonsPopup.ButtonsPopupHandlerInitialize();
        TerceraDatePickerDropDown.DatePickerDropDownHandlerInitialize();
        TerceraNumeric.NumericHandlerInitialize();
        TerceraMultiComboBoxPopup.MultiComboBoxPopupHandlerInitialize();
        PositionExerciseRequestScreen.PositionExerciseRequestScreenHandlerInitialize();
        PropertySetupScreenForIndicator.PropertySetupScreenForIndicatorHandlerInitialize();
        TerceraMessageBox.MessageBoxHandlerInitialize();
        ConfirmationScreen.MessageBoxHandlerInitialize();
        TerceraRiskWarningMessageScreen.RiskWarningMessageScreenHandlerInitialize();
        TerceraBrokerMessageScreen.brokerMessageScreenHandlerInitialize();
        AlertMessageBox.alertMessageScreenHandlerInitialize();
        WorkSpaceManager.workspaceManagerHandlerInitialize();
        ClosePositionsMutually.positionsMutualCloseScreenHandlerInitialize();
        ModifyOrderScreen.modifyOrderScreenHandlerInitialize();
        EditPositionScreen.editPositionScreenHandlerInitialize();
        ExternalScreen.externalScreenHandlerInitialize();
        EntitlementSubscribeDocumentScreen.entitlementSubscribeDocumentScreenHandlerInitialize();
        TerceraAddOverlayScreen.addOverlayScreenHandlerInitialize();
    }
}
export const ApplicationHandlersInitializer = new _ApplicationHandlersInitializer();
